// import React, { createContext, useEffect, useState } from "react";
// import { backend_url } from "../App";

// export const ShopContext = createContext(null);

// const ShopContextProvider = (props) => {

//   const [products, setProducts] = useState([]);

//   const getDefaultCart = () => {
//     let cart = {};
//     for (let i = 0; i < 300; i++) {
//       cart[i] = 0;
//     }
//     return cart;
//   };

//   const [cartItems, setCartItems] = useState(getDefaultCart());

//   useEffect(() => {
//     fetch(`${backend_url}/allproducts`)
//       .then((res) => res.json())
//       .then((data) => setProducts(data))

//     if (localStorage.getItem("auth-token")) {
//       fetch(`${backend_url}/getcart`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/form-data',
//           'auth-token': `${localStorage.getItem("auth-token")}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(),
//       })
//         .then((resp) => resp.json())
//         .then((data) => { setCartItems(data) });
//     }
//   }, [])

//   const getTotalCartAmount = () => {
//     let totalAmount = 0;
//     for (const item in cartItems) {
//       if (cartItems[item] > 0) {
//         try {
//           let itemInfo = products.find((product) => product.id === Number(item));
//           totalAmount += cartItems[item] * itemInfo.new_price;
//         } catch (error) {}
//       }
//     }
//     return totalAmount;
//   };

//   const getTotalCartItems = () => {
//     let totalItem = 0;
//     for (const item in cartItems) {
//       if (cartItems[item] > 0) {
//         try {
//           let itemInfo = products.find((product) => product.id === Number(item));
//           totalItem += itemInfo ? cartItems[item] : 0 ;
//         } catch (error) {}
//       }
//     }
//     return totalItem;
//   };

//   const addToCart = (itemId) => {
//     if (!localStorage.getItem("auth-token")) {
//       alert("Please Login");
//       return;
//     }
//     setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
//     if (localStorage.getItem("auth-token")) {
//       fetch(`${backend_url}/addtocart`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/form-data',
//           'auth-token': `${localStorage.getItem("auth-token")}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ "itemId": itemId }),
//       })
//     }
//   };

//   const removeFromCart = (itemId) => {
//     setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
//     if (localStorage.getItem("auth-token")) {
//       fetch(`${backend_url}/removefromcart`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/form-data',
//           'auth-token': `${localStorage.getItem("auth-token")}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ "itemId": itemId }),
//       })
//     }
//   };

//   const contextValue = { products, getTotalCartItems, cartItems, addToCart, removeFromCart, getTotalCartAmount };
//   return (
//     <ShopContext.Provider value={contextValue}>
//       {props.children}
//     </ShopContext.Provider>
//   );
// };

// export default ShopContextProvider;



import React, { createContext, useEffect, useState } from "react";
import all_products from "../Components/Assets/products";

export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let i = 0; i < 300; i++) {
    cart[i] = 0;
  }
  return cart;
};

const ShopContextProvider = (props) => {
  const [products] = useState(all_products);

  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : getDefaultCart();
  });

  // ✅ Save cart to localStorage anytime it changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const getTotalCartAmount = () => {
    let totalAmount = 0;

    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        const itemInfo = products.find(
          (product) => product.id === Number(item)
        );
        if (itemInfo) {
          totalAmount += cartItems[item] * itemInfo.new_price;
        }
      }
    }

    return totalAmount;
  };

  const getTotalCartItems = () => {
    let totalItem = 0;

    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        totalItem += cartItems[item];
      }
    }

    return totalItem;
  };

  const addToCart = (itemId) => {
    setCartItems((prev) => ({
      ...prev,
      [itemId]: prev[itemId] + 1,
    }));
  };

  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({
      ...prev,
      [itemId]: prev[itemId] > 0 ? prev[itemId] - 1 : 0,
    }));
  };

  const contextValue = {
    products,
    cartItems,
    addToCart,
    removeFromCart,
    getTotalCartAmount,
    getTotalCartItems,
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;